/* ===========================================================================
   Cart
   =========================================================================== */

import {onClickOutside} from '@vueuse/core';
import {effect} from 'vue';
import * as Brevo from './brevo.js';
import {animateClass, loadingClass} from '../settings/settings';
import {timeout} from '../utils';
import {cartStore} from '../stores/cart';

document.querySelectorAll('.js-cart-count')
    .forEach(container => {
        effect(() => container.textContent = cartStore.count);
    });

const $itemCart = $('#js-add-to-cart');

// On stock les éléments qui seront animés :
// $button : correspond au bouton 'Ajouter au panier' de la fiche produit
// $cartCount : correspond au nombre d'item dans le panier, situé dans le header
const $button = $('#js-item-cart-button');
const $continueShopping = $('#js-continue-shopping');
const $sizeSelector = $('#itemSize-Selector');
const $errorMessage = $itemCart.find('.item-add-to-cart-error');
const $loader = $button.find('.loader');

export async function addItemToCart(url, method, body) {
    const response = await fetch(url, {
        method,
        headers: new Headers({
            'X-Requested-With': 'XMLHttpRequest',
        }),
        credentials: 'include',
        body,
    });
    if (!(response.ok && response.status === 200)) {
        return Promise.reject(response);
    }

    const data = await response.json();
    if (data.hasOwnProperty('gtm')) {
        dataLayer.push({ecommerce: null});
        dataLayer.push({
            'event': 'addToCart',
            'ecommerce': {
                'currencyCode': 'EUR',
                add: {
                    products: [data.gtm],
                },
            },
        });
        delete data.gtm;
    }
    Brevo.identify(data.user);
    Brevo.updateCart(data);

    cartStore.count = data.count;

    return data;
}

export function showCartPopup(name, price, image) {
    $('#js-cart .name').html(name);
    $('#js-cart .price').html(price);
    $('#js-cart .img-wrapper').html(image);
    $('#js-cart').addClass('is-active');
}

if ($itemCart.length) {
    const sizeLabel = $itemCart.find('label[for="itemSize-Selector"] small');
    $itemCart.on('change', event => {
        $button
            .prop('disabled', false)
            .removeClass(`${animateClass} not-allowed`);
        const stock = Number(event.target.dataset.stock || 0);
        if (stock === 1) {
            sizeLabel.text(`Plus que ${stock} ${stock > 1 ? 'paires' : 'paire'} en stock`).removeClass('is-hidden');
        } else {
            sizeLabel.text('').addClass('is-hidden');
        }
    });

    $itemCart.on('submit', async function (e) {
        e.preventDefault();
        const formData = new FormData(this);
        if ($sizeSelector[0] instanceof HTMLSelectElement && !formData.get('add_to_cart[sizes]')) {
            $errorMessage.text('Veuillez sélectionner une taille').removeClass('is-hidden');
            return;
        }
        $button.prop('disabled', true);
        // On lance les animations
        $loader.addClass(loadingClass);
        await addItemToCart(this.action, this.method, formData);

        // Une fois les données reçus et envoyées
        // On supprime les animations des éléments avec un délais
        $loader.removeClass(loadingClass);
        // On place les éléments dans la popin et on change le texte du bouton
        $button.find('span.button-add-cart').html('Paire ajoutée au panier !');
        showCartPopup(
            $('#js-item-header h1').text(),
            $('#js-item-header .item-price').first().text(),
            $('.item-carousel > :first-child img').clone(),
        );

        await timeout(1500);
        $button.removeClass(`${loadingClass}`);
        $continueShopping.removeClass('is-hidden');

        await timeout(200);
        if (document.querySelector('select[name="add_to_cart[sizes]"]')) {
            $button.find('span.button-add-cart').html('Ajouter au panier');
            $button.prop('disabled', false);
            $('li.l-dropdown-item[data-value="' + $('#js-add-to-cart .l-dropdown-selected-value').attr('data-value') + '"]').addClass('l-dropdown-item-disabled');
        }
    });
}

$(document).ready(function () {
    $sizeSelector.next('.submit-share-add-cart').click(function () {
        $('li[data-value=""]').remove();
    });

    if ($('.command-thank-you').length > 0) {
        Brevo.orderCompleted();
    }

    $('#js-cart-close').on('click', event => {
        event.preventDefault();
        $('#js-cart').removeClass('is-active');
    });

    const quickAddToCartForms = document.querySelectorAll('.js-quick-add-to-cart:not([data-v-app] .js-quick-add-to-cart)'); // Prevent selecting forms inside Vue components
    quickAddToCartForms.forEach(form => {
        const itemCard = form.closest('.item');
        form.addEventListener('submit', async event => {
            event.preventDefault();
            const submitButton = event.submitter;
            submitButton.disabled = true;
            const formData = new FormData(form);
            if (submitButton.value) {
                formData.append(submitButton.name, submitButton.value);
            }
            await addItemToCart(form.action, form.method, formData);
            showCartPopup(
                itemCard.querySelector('.item-infos .item-name').innerText,
                itemCard.querySelector('.item-infos .item-price').innerText,
                itemCard.querySelector('.product-image').cloneNode(),
            );
        });
    });

    const quickAddToCartButtons = document.querySelectorAll('.js-add-to-cart-button:not([data-v-app] .js-add-to-cart-button)'); // Prevent selecting forms inside Vue components
    quickAddToCartButtons.forEach(button => {
        const itemCard = button.closest('.item');
        const addToCartForm = itemCard.querySelector('.item-add-to-cart');
        button.addEventListener('click', () => addToCartForm.classList.toggle('active'));
        onClickOutside(button, () => addToCartForm.classList.remove('active'));
    });
});

$('.command-button-remove').on('click', function (e) {
    if ($(this).hasClass('user-logged')) {
        Brevo.cartDeleted();
    }
});
